module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center-panel",
    attrs: {
      "id": "page__prices"
    }
  }, [_c('md-content', {
    directives: [{
      name: "loader-overlay",
      rawName: "v-loader-overlay",
      value: (_vm.progress),
      expression: "progress"
    }],
    staticClass: "md-elevation-1",
    attrs: {
      "md-theme": "white"
    }
  }, [_c('PricesMenu'), _vm._v(" "), _c('sort-table', {
    ref: "table",
    attrs: {
      "columns": _vm.tableColumns,
      "per-page": _vm.perPage,
      "total": _vm.pricesAmount,
      "link": "",
      "table-id": "prices",
      "tableHeight": "calc(100% - 48px)"
    },
    on: {
      "refresh": _vm.getPrices,
      "create": _vm.addPrice
    },
    scopedSlots: _vm._u([{
      key: "from",
      fn: function(scope) {
        return [_c('span', {
          attrs: {
            "no-breack-words": ""
          }
        }, [_vm._v(" " + _vm._s(scope.item.zone_id_from ? scope.item.zone_from.name + ' (направление)' : scope.item.city_from.name + ' (город)'))])]
      }
    }, {
      key: "to",
      fn: function(scope) {
        return [_c('span', {
          attrs: {
            "no-breack-words": ""
          }
        }, [_vm._v(" " + _vm._s(scope.item.zone_id_to ? scope.item.zone_to.name + ' (направление)' : scope.item.city_to.name + ' (город)'))])]
      }
    }, {
      key: "type",
      fn: function(scope) {
        return [_vm._v(" " + _vm._s(parseInt(scope.item.type) == 2 ? 'По объёму' : 'По весу'))]
      }
    }, {
      key: "is_min",
      fn: function(scope) {
        return [_vm._v(" " + _vm._s(parseInt(scope.item.is_min) == 1 ? 'Да' : 'Нет'))]
      }
    }, {
      key: "actions",
      fn: function(scope) {
        return [_c('z-icon-button', {
          attrs: {
            "icon": ['fa', 'clone'],
            "rounded": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              $event.preventDefault();
              _vm.clone(scope.item.id)
            }
          }
        }), _vm._v(" "), _c('z-icon-button', {
          attrs: {
            "icon": ['fa', 'trash'],
            "danger-light": "",
            "rounded": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              $event.preventDefault();
              _vm.onRemove(scope.item.id)
            }
          }
        })]
      }
    }]),
    model: {
      value: (_vm.prices),
      callback: function($$v) {
        _vm.prices = $$v
      },
      expression: "prices"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7da087a4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/cost/views/Prices.vue
// module id = 1212
// module chunks = 0